import i18n from '../../language/index'
import { create_title } from '@/base/titleData'
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  mb_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
    font: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    lineHeight: {
      radio_val: 'default',
      default: {
        lineHeight: 58
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 1,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 1,
        borderStyle: 'solid'
      }
    },
    linkType: '_blank',
    title: create_title(i18n.t('widgets_basic_article_classification_edit_317'))
  },
  mb_widgets_infor: {
    font: {
      radio_val: 'default',
      default: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fontFamily: 'Arial',
        fontSize: 16,
        color: 'rgba(101, 113, 128, 1)',
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'normal',
        selectColor: 'rgba(101, 113, 128, 1)',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    lineHeight: {
      radio_val: 'default',
      default: {
        lineHeight: 50
      },
      custom: {
        lineHeight: 58
      }
    },
    splitLine: {
      radio_val: 'default',
      default: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 1,
        borderStyle: 'solid'
      },
      custom: {
        borderColor: 'rgba(236, 236, 236, 1)',
        borderWidth: 1,
        borderStyle: 'solid'
      }
    },
    title: create_title(i18n.t('widgets_basic_article_classification_edit_317'))
  },
  listArr: {
    articleType: 'all', // 分类选择类型all,appoint
    articleCategory: 'newsList', // 文章类型newsList,caseList,helpList
    filterByIds: [],  // 指定的ids
    moduleStyle: 0
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_article_classification/style.js